import { useState } from "react";
import { toast } from "react-toastify";
import { post } from "../networking/RequestService";
import useGetProfile from "./useGetProfile";
import { useExtensionContext } from "../modules/extension/ExtensionContext";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useSetProfileFollowOption = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const { profile } = useExtensionContext();
    const { refetch: getProfile } = useGetProfile();

    const setProfileFollowOption = async (option) => {
        setLoading(true);
        setError(null);

        try {
            const payload = {
                fn: "setProfileFollowOption",
                profileId: profile.id,
                option: option,
            };

            const response = await post(payload);

            if (response.data.stat === "nok") {
                toast.warning(response?.data?.text);
                return { success: false };
            } else if (response.data.stat === "ok") {
                toast.success(response?.data?.text);
                await getProfile();
                return { success: true };
            }
            return { success: false };
        } catch (err) {
            const errorMessage = apiErrorText(err);
            setError(errorMessage);
            toast.error(errorMessage);
            return { success: false, error: errorMessage };
        } finally {
            setLoading(false);
        }
    };

    return {
        setProfileFollowOption,
        loading,
        error,
    };
};

export default useSetProfileFollowOption;
